require("./gallery");
require("./cookies");
require("./calendar");
require("./booking");
require("./favorite");
require("./blog");
require("./filters");
require("./autocomplete");
require("./article");
require("./search");
require("./filters");
require("./tours");
require("./experiences");
require("./exchangeCurrencies");
require("./sidepanel");
require("./ta-widget");



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/index.js